import React from 'react';
import JavascriptClasses from './JavascriptClasses.jsx';
import JavascriptClassesInheritance from './JavascriptClassesInheritance.jsx';
import JavascriptClassesStatic from './JavascriptClassesStatic.jsx';

export default function JsClasses() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Classes</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/classes' className='underline'>JS Classes</a></li>
<li><a href='/javascript/classes/inheritance' className='underline'>JS Class Inheritance</a></li>
<li><a href='/javascript/classes/static' className='underline'>JS Class Static</a></li>
      </ul>
    </div>
  );
}
